import { PaymentMethodType, SinglePaymentCriteria } from '@nemuru-eng/js-api-client';

import { IconByAllowedPaymentMethodType } from '@/components/shared/components/PricingsTable/constants/IconByAllowedPaymentMethodType';
import { SizedIconWithCircle } from '@/components/shared/components/SizedIconWithCircle';
import { Text } from '@/components/shared/components/Text';
import { ApplicationType, SinglePaymentApplicationType } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const singlePaymentTypeFieldColumn = ({
  applicationType,
  flex,
}: {
  applicationType: SinglePaymentApplicationType;
  flex?: number;
}) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.15,
    disableOnRowClick: true,
    field: 'asset_type',
    sortable: false,
    headerName: <Text tId={'TYPE'} />,
    renderCell: (rowData: { row: SinglePaymentCriteria }) => {
      return (
        <SizedIconWithCircle
          variant={'medium'}
          backgroundColor={palette.grey[50]}
          iconColor={palette.grey[500]}
          customBorderRadius={customBorderRadius.button}
          iconName={IconByAllowedPaymentMethodType(
            applicationType === ApplicationType.A2A_PAYMENT
              ? PaymentMethodType.A2A_PAYMENT
              : PaymentMethodType.CARD_PAYMENT,
          )}
          copyToClipboard={{ value: rowData.row.id, textId: 'COPY_SINGLE_PAYMENT_ID' }}
        />
      );
    },
  };
};
